import { css } from "@emotion/react";
import { theme } from "@/constants/theme";

export const linkStyles = () =>
  css({
    color: theme.palette.secondary.dark,
    "&:hover": {
      color: theme.palette.text.secondary,
    },
    "&:active": {
      color: theme.palette.secondary.main,
    },
  });
